// External deps
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

// Internal deps
import useCalendar from '../../../hooks/useCalendar';
import { getMonth } from '../../../utils/formatUtils';

import Month from './components/Month/Month';

const MonthlyCalendar = ({
  date,
  showActions,
  showHeader,
  onClickDayBefore,
  onClickNextDay,
  handleSelectDay,
  arrayDate,
  manualChange,
  minDate,
  maxDate,
  disabled,
  disabledEditStateCancelOrFinish,
  isSummaryModal,
  lineBlockedBySap
}) => {
  const [currentMonth, setCurrentMonth] = useState(getMonth());
  const regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/g;
  const { monthIndex, setMonthIndex, yearIndex, setYearIndex } = useCalendar();

  useEffect(() => {
    setCurrentMonth(getMonth(monthIndex, yearIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthIndex]);

  useEffect(() => {
    // date: debe ser string formato YYYY-MM-DD...
    if (!!date || regex.test(date)) {
      setYearIndex(dayjs(date).year());
      const monthIdx = dayjs(date).month();

      setMonthIndex(monthIdx);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <div>
      <Month
        arrayDate={arrayDate}
        disabled={disabled}
        disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
        isSummaryModal={isSummaryModal}
        lineBlockedBySap={lineBlockedBySap}
        manualChange={manualChange}
        maxDate={maxDate}
        minDate={minDate}
        month={currentMonth}
        onClickDay={handleSelectDay}
        onClickDayBefore={onClickDayBefore}
        onClickNextDay={onClickNextDay}
        showActions={showActions}
        showHeader={showHeader}
      />
    </div>
  );
};

MonthlyCalendar.propTypes = {
  showActions: PropTypes.bool,
  showHeader: PropTypes.bool,
  onClickDayBefore: PropTypes.func,
  onClickNextDay: PropTypes.func,
  handleSelectDay: PropTypes.func,
  date: PropTypes.string,
  arrayDate: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  manualChange: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  disabled: PropTypes.bool,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  isSummaryModal: PropTypes.bool,
  lineBlockedBySap: PropTypes.bool.isRequired
};

MonthlyCalendar.defaultProps = {
  showActions: true,
  showHeader: true,
  onClickDayBefore: () => {},
  onClickNextDay: () => {},
  handleSelectDay: () => {},
  date: '',
  arrayDate: [],
  manualChange: true,
  minDate: '',
  maxDate: '',
  disabled: false,
  isSummaryModal: false
};

export default MonthlyCalendar;
